import { ArrowUpOnSquareIcon } from '@heroicons/react/24/solid';
import React from 'react';
import { twMerge } from 'tailwind-merge';

import Icon, { IconVariant } from 'components/Icon/Icon';
import Panel from 'components/Panel/Panel';

interface PanelProps {
  children: React.ReactNode;
  displayItemClassName?: string;
  key?: string;
  title: string;
}

const DisplayItem = ({
  children,
  key,
  displayItemClassName,
  title,
}: PanelProps) => {
  const panelClassName = twMerge(
    'bg-kira-slate-50',
    'border-kira-slate-200',
    'flex',
    'h-16',
    'align-middle',
    'hover:bg-kira-blue-100',
    'hover:ring-2',
    'hover:ring-kira-blue-800',
    'hover:cursor-pointer',
    'hover:transition',
    'space-y-0',
    'overflow-visible',
    'p-4',
    'rounded-lg',
    'w-full',
    displayItemClassName
  );

  return (
    <Panel panelClassName={panelClassName} key={key}>
      <Icon icon={<ArrowUpOnSquareIcon />} variant={IconVariant.MEDIUM} />
      <div className="flex w-full items-center justify-between align-middle">
        <div className="prose-body-md-med pl-2">{title}</div>
        {children}
      </div>
    </Panel>
  );
};

export default DisplayItem;
